<template>
    <div id="retail_delivery_report_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">RDR & Rizon Connect Integration</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
                </div>
                <div class="d-flex align-items-center pl-3 mt-1">
                    <router-link v-if="canAddReport" class="btn btn-primary"
                        v-bind:to="{ name: 'RetailDeliveryReportCreate' }"> <i class="fp-add"> </i> New
                        RDR</router-link>
                    <p class="mb-0 text-center flex-grow-1">
                        <b>
                            To register a vehicle for Rizon Connect that is NOT in your RDR Log please contact
                            <a :href='"mailto:" + systemParamValue' style="text-transform: uppercase;">{{
                                systemParamValue }}</a>
                        </b>
                    </p>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content retailDeliveryReportList">
                        <data-table-filter-config :moduleName="'retailDeliveryReportList'"
                            :removeLineButtonVisibility="true" :addFilterButtonVisibility="true"
                            @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                :moduleName="'retailDeliveryReportList'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table ref="retailDeliveryReportList" mode="remote" title="Retail Report Delivery"
                                @on-page-change="onPageChange" @on-selected-rows-change="selectionChanged"
                                @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange" :totalRows="totalRecords" :columns="userColumns"
                                :rows="rows" :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown: dropDownPerPage,
                                    dropdownAllowAll: false,
                                }" :select-options="{
                                    enabled: false,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }" :search-options="{
                                    enabled: false,
                                }">

                                <template slot="table-row" slot-scope="props" v-for="(row, key) in rows">
                                    <div :key="key">
                                        <div v-if="props.column.field == 'action'">
                                            <a v-if="canViewLog" title="View Log"
                                                v-on:click.prevent="goToGetLogInfo(props.row.linked_rizon_id)"
                                                class="fp-log-file-format" href="javascript:void(0)"></a>
                                            <router-link title="Edit" v-if="canEditReport" class="fp-edit"
                                                v-bind:to="{ name: 'RetailDeliveryReportEdit', params: { id: props.row.id } }"></router-link>
                                            <a @click="showRizonConnectModal(props.row.id)"
                                                v-if="props.row.entered_by_id == userObj.id && props.row.rizon_connect == 'No'"
                                                style="cursor: pointer;" title="Add Rizon Connect">
                                                <img :src="'/static/images/rizon-connect-logo.png'"
                                                    alt="Rizon Connect Logo" style="height: 18px;margin-top: -7px;">
                                            </a>
                                        </div>
                                        <div v-else-if="props.column.field == 'document_pdf_link'">
                                            <span
                                                v-if="props.row.document_pdf_link == '' || props.row.document_pdf_link == null">-</span>
                                            <a v-else v-on:click="goToGetDocumentPath($event, props.row)"
                                                title="View Document" href="" style="font-size: 15px;"><i
                                                    class="fp-text-document"></i></a>
                                        </div>
                                        <div v-else-if="props.column.field == 'document_link'">
                                            <a v-if="props.row.document_link" class="color-blue" title="Document Link"
                                                target="_blank" :href="props.row.document_link">Link</a>
                                        </div>
                                        <div v-else>
                                            {{ props.formattedRow[props.column.field] }}
                                        </div>
                                    </div>
                                </template>

                            </vue-good-table>
                            <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>
                    </div>
                </div>
                <div class="modal fade" v-if="showRizonModal" id="uploadRizonConnect" tabindex="-1" role="dialog"
                    aria-labelledby="uploadRizonConnectLabel" data-backdrop="static">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div style="display: flex; justify-content: center; align-items: center;" class="mt-4 mb-3">
                                <img :src="logoPath" alt="Dealer Pro" style="height: 70px; margin-right: 7px">
                            </div>
                            <div class="pl-5 pr-5 mt-1">
                                <h4><strong>Rizon Connect Registration</strong></h4>
                                <DropZone :showUploadedFiles="false" :maxFileLimit='1' :docErrorMsg="docErrMsg"
                                    :dropzoneRequired="true" :dropZonePreviewFiles="[]" :dropzoneCol="'col-md-12'"
                                    :fileSizeLimit="20"
                                    :dropzoneLabel="'Upload the signed Rizon Connect terms & conditions'"
                                    @dropzone-update-files="updateFiles" />
                            </div>
                            <div class="d-flex justify-content-around mt-4 mb-3">
                                <button type="button" @click="uploadRizonConnectRegistration()"
                                    class="btn-lg btn-primary" style="width: 150px;">Upload
                                </button>
                                <button type="button" @click="closeRizonConnectUploadModal()" class="btn-lg btn-primary"
                                    style="width: 150px;">Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <audit-log-popup :logs="logs" :popUpTitle="popUpTitle"></audit-log-popup>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import EventBus from "../event-bus";
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
Vue.use(VueGoodTable);

import { commonMixins } from '../../mixins/commonMixins';
import { dataTableMixins } from '../../mixins/dataTableMixins';
import { contractMixins } from '../../mixins/contractMixins';

import DropZone from '../DropZone.vue';

import AuditLogPopUp from "../AuditLogPopUp.vue";
Vue.component("audit-log-popup", AuditLogPopUp);

export default {
    name: "RetailDeliveryReportList",
    components: {
        DropZone,
        customPagination: () => import('@/components/layout/CustomPagination'),
        dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
        clearCacheData: () => import('@/components/ClearCacheData'),
        appFooter: () => import('@/components/Footer'),
    },
    mixins: [commonMixins, dataTableMixins, contractMixins],
    metaInfo() {
        return { title: "Retail Delivery Report List | " + process.env.COPYRIGHT_NAME }
    },
    data: () => ({
        permissions: [],
        cantAccessPage: '',
        userColumns: [],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
                filterable: false,
                hidden: false
            },
            {
                label: 'VIN',
                field: 'vin',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "VIN", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Delivery Date',
                field: 'delivery_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Delivery Date'", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Odometer',
                field: 'odometer',
                fpFieldType: "integer",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Odometer", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Dealer Code',
                field: 'dealer_code',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Dealer Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Dealer Name',
                field: 'dealer_name',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Dealer Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Customer Code',
                field: 'customer_code',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Customer Name',
                field: 'customer_name',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Name'", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Body Builder',
                field: 'body_builder',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Body Builder", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Date Submitted',
                field: 'date_submitted',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Date Submitted'", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Dealer Salesperson Name',
                field: 'dealer_salesperson_name',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Dealer Salesperson Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Entered By',
                field: 'entered_by',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Entered By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Document PDF Link',
                field: 'document_pdf_link',
                fpFieldType: "text",
                hidden: false,
                filterable: false,
            },
            {
                label: 'Rizon Connect?',
                field: 'rizon_connect',
                fpFieldType: "option",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Rizon Connect?", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Yes', 'No'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'RDR Verified By',
                field: 'rdr_verified_by',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "RDR Verified By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'RDR Verification Date',
                field: 'rdr_verification_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "RDR Verification Date'", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Incentive Program Used?',
                field: 'incentive_program_used',
                fpFieldType: "option",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Incentive Program Used?", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Yes', 'No'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Program Name',
                field: 'program_name',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Program Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Program #',
                field: 'program_number',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Program #", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Company Name',
                field: 'company_name',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Company Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Rizon Connect Customer Name',
                field: 'rizon_customer_name',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Rizon Connect Customer Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Signature Collected?',
                field: 'signature_collected',
                fpFieldType: "option",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Signature Collected?", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Y', 'N'],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Rizon Connect Customer Email',
                field: 'rizon_customer_email',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Rizon Connect Customer Email", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Rizon Connect Customer Phone',
                field: 'rizon_customer_phone',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Rizon Connect Customer Phone", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Date Signed',
                field: 'date_signed',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Date Signed'", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Document Link',
                field: 'document_link',
                fpFieldType: "text",
                hidden: false,
                filterable: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Document Link", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Reg Date',
                field: 'reg_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Reg Date'", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Exp Date',
                field: 'exp_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Exp Date'", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Rizon Connect Verified By',
                field: 'rizon_connect_verified_by',
                fpFieldType: "text",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Rizon Connect Verified By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Rizon Connect Verification Date',
                field: 'rizon_connect_verification_date',
                fpFieldType: "date",
                hidden: false,
                filterable: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Rizon Connect Verification Date'", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Cust Admin',
                field: 'cust_admin',
                fpFieldType: "text",
                hidden: false,
                filterable: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Cust Admin", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [],
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
        ],
        rows: [],
        totalRecords: 0,
        loading: false,
        canEditReport: false,
        canAddReport: false,
        pageKey: "_retail_delivery_report_list_",
        errorMsg: "",
        userObj: '',
        logoPath: '',
        showRizonModal: false,
        docErrMsg: "",
        files: [],
        tempReportId: 0,
        canViewLog: '',
        popUpTitle: "Retail Delivery Report Internal Activity Log Details",
        logs: [],
        systemParamValue: ''
    }),
    created: function () {
        this.logoPath = process.env.LOGO_PATH;
    },
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_create_retail_delivery_report') {
                        self.canAddReport = true;
                    }
                    if (permissions[i].name == 'ev_edit_retail_delivery_report') {
                        self.canEditReport = true;
                    }
                    if (permissions[i].name == 'ev_list_retail_delivery_report') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'ev_view_log_delivery_report') {
                        self.canViewLog = true;
                    }
                }
            }
        },
    },
    mounted: function () {
        var self = this;
        self.userObj = JSON.parse(localStorage.getItem('user_obj'));
        self.getPermissions();
        self.loadFieldData(
            ['system_params_search'],
            'retail_delivery_report_list_page_email'
        );
    },
    methods: {
        updateFiles(files) {
            this.files = files;
        },
        showRizonConnectModal(id) {
            this.tempReportId = id;
            this.showRizonModal = true;
            this.$nextTick(() => {
                $('#uploadRizonConnect').modal('show');
            });
        },
        uploadRizonConnectRegistration() {
            this.docErrMsg = '';
            if (this.files.length > 0) {
                this.createRetailDeliveryReport('upload-file');
            } else {
                this.docErrMsg = 'Please upload the signed Rizon Connect terms & conditions.';
            }
        },
        closeRizonConnectUploadModal() {
            this.showRizonModal = false;
            this.docErrMsg = '';
            this.fileErrorMsg = '';
            this.files = [];
            this.tempReportId = 0;

            $('#uploadRizonConnect').modal('hide');
        },
        createRetailDeliveryReport() {
            var self = this;
            self.loading = true;

            var formData = new FormData();
            formData.append('files', self.files);
            formData.append('reportId', self.tempReportId);

            $.ajax({
                url: process.env.ROOT_API + "/retail-delivery-report/create",
                type: "POST",
                headers: this.ajxHeaders,
                data: formData,
                contentType: false,
                processData: false,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == 'success') {
                        self.thankYouSwalPopUp();
                    }
                },
                error: function (jqXHR) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'create-retail-delivery-report');
                }
            });
        },
        thankYouSwalPopUp() {
            this.$swal({
                title: 'Thank You!',
                text: 'Your Registration Has Been Received and Will Be Processed by the Rizon Team.',
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'Close',
                allowOutsideClick: false
            }).then((result) => {
                this.closeRizonConnectUploadModal();
                this.loadList();
            });
        },
        cancelAll: function () {
            this.$refs.listRetailDeliveryReport.unselectAllInternal();
        },
        selectionChanged(param) {
            if (param.selectedRows.length == 100) {
                EventBus.$emit('clear-selection', false);
            } else {
                EventBus.$emit('clear-all-flags', false);
            }
        },
        loadList() {
            var self = this;
            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
            };
            $.ajax({
                url: process.env.ROOT_API + "/retail-delivery-report/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'retail-delivery-report-list');
                }
            });
        },
        goToGetDocumentPath(event, row) {
            event.preventDefault();
            var self = this;
            var path = row.document_pdf_link;
            var flag = '';
            var id = 0;

            self.getDocumentPath(id, path, flag);
        },
        goToGetLogInfo(logId) {
            var self = this;
            var logFlag = 'RETAIL_DELIVERY_REPORT_AUDIT';
            self.getLogInfo(logId, logFlag);
        },
    }
};
</script>
<style scoped>
.data-table table.vgt-table .fp-edit {
    font-size: 17px;
}

.data-table table.vgt-table .fp-log-file-format {
    font-size: 17px;
}

.loader-vvg {
    z-index: 1063;
}
</style>



// WEBPACK FOOTER //
// src/components/retailDeliveryReport/RetailDeliveryReportList.vue